import { connect } from 'react-redux'
import ProductsView from '../components/ProductsView'
import {loadProducts, changeSearchTerm} from '../modules/products'
import {applicationLaunch, appReset} from "../../../store/application";
import {getProducts, getFavorites} from "../selectors/products";

const mapDispatchToProps = {
  loadProducts: loadProducts,
  next: (app_guid, product_id) => (dispatch, getStore) => {
    const locale = getStore().i18n.locale;
    dispatch(applicationLaunch(app_guid, product_id, locale))
  },
  appReset: appReset,
  changeSearchTerm: changeSearchTerm
};

const mapStateToProps = (state) => ({
  products: getProducts(state),
  favorites: getFavorites(state),
  searchTerm: state.products.searchTerm,
  selectedProduct: state.products.selectedProduct,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsView)


// WEBPACK FOOTER //
// ./src/components/Products/containers/ProductsContainer.js